//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import helpBanner from '~/components/help/helpBanner.vue' // 面包屑
import { setAppBar, shouldHideProgress } from '~/assets/js/utils.js'
export default {
  components: {
    'help-banner': helpBanner
  },
  layout (context) {
    return context.route.query?.type ? 'empty' : 'default'
  },
  async asyncData ({ $api, store, redirect, route, params }) {
    const { locale = 'en', countryCode } = store.state
    const code = params?.id?.replace('.html', '')
    // 获取tab数据
    const res = await $api.common.v3Server({ Routes: 'wikifxarticle$vpsarticleinfo', BasicData: store.getters?.getDiffBasic }, { languageCode: locale, countryCode, code, platform: 1, upStreamIp: '404' }).catch(() => {})
    const contentObj = res.wikifxarticle.vpsarticleinfo.data || {}
    return { contentObj }
  },
  data () {
    return {
      isApp: this.$route.query?.type || 0,
      contentObj: {},
      appBarActionHandler: null
    }
  },
  computed: {
    ...mapState(['suffix']),
    appUserAgent () {
      return this.$route.query?.userAgent || this.$store?.state?.appUserAgent || ''
    },
    isNewApp () {
      return shouldHideProgress(this.appUserAgent)
    }
  },
  mounted () {
    if (this.isNewApp) this.registerAppBarAction()
    // 新版本 App 页面加载完成后通知隐藏加载进度
    if (shouldHideProgress(this.appUserAgent) && typeof window.Communication === 'function') {
      window.Communication('hideProgress', JSON.stringify(''))
    }
    if (this.isNewApp) this.notifyAppBarConfig()
    this.$nextTick(() => {
      this.getOpen()
    })
  },
  beforeDestroy () {
    if (window.appBarAction === this.appBarActionHandler) delete window.appBarAction
  },
  methods: {
    registerAppBarAction () {
      this.appBarActionHandler = (action) => {
        const actionType = typeof action === 'string' ? action : action?.type
        if (actionType === 'back') this.$router.go(-1)
      }
      window.appBarAction = this.appBarActionHandler
    },
    notifyAppBarConfig () {
      if (!this.isNewApp) return

      setAppBar({
        leftIcons: String(this.$route.query?.source || '').toLowerCase() === 'app' ? ['close'] : ['back'],
        backgroundColor: '#fff',
        fontColor: '#292A2E',
        rightIcons: ['refresh']
      }, this.appUserAgent)
    },
    getOpen () {
      const dom = document.querySelectorAll('.content-box a')
      dom.forEach((item) => {
        item.addEventListener('click', (item1) => {
          item1.preventDefault()
          if (this.isApp) {
            if (item.href.includes(`vps.wikifx.${this.suffix}`)) return window.open(item.href + '?type=1')
            else return window?.Communication('webOutboundBrowser', JSON?.stringify({ url: item.href }))
          } else {
            window.open(item.href)
          }
        })
      })
    }
  }
}
